<template>
    <form method="get" :action="url" class="o-search__traghetti" @submit="onSubmit">
        <input type="hidden" name="action" value="start" />
        <input type="hidden" name="ticket" value="oneway" />
        <div class="o-search__fields" ref="fields">
            <route-selector
                prefix="out_"
                :origin="outOrigin"
                :destination="outDestination"
                @update:origin="outOrigin = $event"
                @update:destination="outDestination = $event"
            ></route-selector>

            <div class="is-single">
                <datepicker
                    :availableDates="availableDates.out"
                    ref="datepicker"
                    required
                    name="out_date"
                    title="Select a date"
                    placeholder="Date"
                    icon="date"
                    v-model="date"
                    :minDate="minDate.format('DD/MM/YYYY')"
                    @show="scrollToTop"
                ></datepicker>
            </div>

            <passengers-count ref="passengers" v-model="passengers"></passengers-count>

            <div>
                <button class="btn btn-primary w-100" type="submit">Search</button>
            </div>
        </div>
    </form>
</template>

<script>
import PassengersCount from '../components/PassengersCount.vue'
import Datepicker from '../components/Datepicker.vue'
import RouteSelector from '../components/RouteSelector.vue'

export default {
    components: {
        PassengersCount,
        RouteSelector,
        Datepicker,
    },
    data() {
        return {
            outOrigin: '',
            outDestination: '',
            date: '',
            passengers: {
                adl: 0,
                chd: 0,
                inf: 0,
            },
            url: window.venezialines.booking_page,
            availableDates: {
                out: [],
            },
            cancelSource: {
                out: null,
            }
        }
    },
    mounted() {
        const params = new URLSearchParams(window.location.search)

        this.$nextTick(() => {
            this.outOrigin = params.get('out_origin')
            this.outDestination = params.get('out_destination')
            this.date = params.get('out_date') || ''
            this.passengers.adl = params.get('pax_adl') ? parseInt(params.get('pax_adl')) : 0
            this.passengers.chd = params.get('pax_chd') ? parseInt(params.get('pax_chd')) : 0
            this.passengers.inf = params.get('pax_inf') ? parseInt(params.get('pax_inf')) : 0
        })
    },
    computed: {
        minDate() {
            return moment()
        },
        outRoute() {
            return [this.outOrigin, this.outDestination]
        },
    },
    watch: {
        outRoute() {
            this.getAvailableDates(this.outOrigin, this.outDestination, 'out')
        }
    },
    methods: {
        getAvailableDates(origin, destination, leg) {
            if (this.cancelSource[leg]) {
                this.cancelSource[leg].cancel()
            }

            if (!this.outOrigin || !this.outDestination || this.outOrigin == this.outDestination) {
                return Promise.resolve()
            }

            this.cancelSource[leg] = axios.CancelToken.source();

            axios.get(window.venezialines.ajaxurl, {
                params: {
                    action: 'get_schedule',
                    origin_id: origin,
                    destination_id: destination,
                    date_from: moment().format('YYYY-MM-DD'),
                    date_to: moment().add(1, 'year').endOf('year').format('YYYY-MM-DD'),
                },
                cancelToken: this.cancelSource[leg].token,
            }).then(response => {
                this.availableDates[leg] = response.data.map(trip => moment(trip.departure).format('YYYY-MM-DD'))
                this.cancelSource[leg] = null
            }).catch(err => {})
        },
        onSubmit(e) {
            let valid = true
            if (!this.date) {
                this.$refs.datepicker.show()
                valid = false
            }
            else if (this.passengers.adl < 1) {
                this.$refs.passengers.toggle()
                valid = false
            }
            valid || e.preventDefault()
        },
        scrollToTop() {
            this.$scrollTo(this.$refs.fields, { offset: -20 })
        }
    }
}
</script>